import cx from 'classnames';
import { Spacings } from '../../wp-blocks/helpers/SpacingControls/RangeControl';
import styles from 'styles/spacings.module.scss';

export const withWPStyles = (spacing: Spacings) => {
  const classes = cx({
    [styles[`spacing-top-${spacing?.top}`]]: typeof spacing?.top === 'number',
    [styles[`spacing-bottom-${spacing?.bottom}`]]:
      typeof spacing?.bottom === 'number',
    [styles[`spacing-top-mobile-${spacing?.topMobile}`]]:
      typeof spacing?.topMobile === 'number',
    [styles[`spacing-bottom-mobile-${spacing?.bottomMobile}`]]:
      typeof spacing?.bottomMobile === 'number',
  });

  return classes;
};
